import React from "react"
import { Icon as ChakraIcon, IconProps } from "@chakra-ui/react"

const PlayIcon = (props: IconProps) => (
  <ChakraIcon viewBox="0 0 24 24" {...props}>
    <path fill="currentColor" d="M8 5v14l11-7z" />
  </ChakraIcon>
)

export default PlayIcon
